module.exports = __webpack_public_path__ + "img/company.4ff2b07b.png";